import { colors } from '../base/colors'

export const formLabel = {
  styleOverrides: {
    root: {
      color: colors.text.primary,
      marginBottom: '4px'
    }
  }
}
